import React from 'react'
import StudentList from './StudentList'
import LoadingOverlay from './LoadingOverlay'

export default function SearchResults({ searchResults, loading, onDelete }) {
  let resultMessage = ''
  if (searchResults.length === 0) {
    resultMessage = 'No matches found'
  } else if (searchResults.length === 1) {
    resultMessage = 'We found one student matching your search'
  } else {
    resultMessage = 'Multiple students found. Please select from results below'
  }

  return (
    <div style={{ position: 'relative', minHeight: '200px' }}>
      {loading ? (
        <LoadingOverlay />
      ) : (
        <>
          <div role="status" className="mt-4 text-center">
            {resultMessage}
          </div>
          <StudentList data={searchResults} onDelete={onDelete} />
        </>
      )}
    </div>
  )
}
